import type { PropsWithChildren, ReactNode } from 'react';
import cn from 'classnames';

import styles from './TableWrapper.module.scss';

interface ITableContainer {
  title: string;
  actions?: ReactNode;
  isTabContent?: boolean;
}

function TableWrapper({ title, actions, children, isTabContent = false }: PropsWithChildren<ITableContainer>) {
  return (
    <div
      className={cn(styles.tableWrapper, {
        [styles.tabTableWrapper as string]: isTabContent,
      })}
    >
      <div className={styles.tableHeader}>
        <h2 className="fs-20 fw-semibold">{title}</h2>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      {children}
    </div>
  );
}

export default TableWrapper;
